// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2W0Nw","field":"styles_field__10foU","fieldCol":"styles_fieldCol__3-lw8","diffCol":"styles_diffCol__2GjMI","diff":"styles_diff__DRpno"};